

























import { Component, Vue } from "vue-property-decorator";
@Component
export default class ErrorPage extends Vue {
  protected loginAsDifferentUser(): void {
    const callback = `${process.env.VUE_APP_URL}/auth/callback`;
    const loginUrl = `${process.env.VUE_APP_API_LARAVEL_URL}/auth/login?redirect=${encodeURIComponent(callback)}&app=${process.env.VUE_APP_SSO_APP_SLUG}`;
    // Log out of SSO first, then redirect to login page
    window.location.replace(
      `${process.env.VUE_APP_API_LARAVEL_URL}/auth/logout?redirect=${encodeURIComponent(loginUrl)}`
    );
  }
}
